// adminApi
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function blockUser(userId) {
  const response = await fetch(`${API_BASE_URL}/block-user/${userId}`, {
    method: 'POST',
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при блокировке пользователя');
  }

  return data;
}

export async function unblockUser(userId) {
  const response = await fetch(`${API_BASE_URL}/unblock-user/${userId}`, {
    method: 'POST',
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при разблокировке пользователя');
  }

  return data;
}

export async function adminLogin(password) {
  const response = await fetch(`${API_BASE_URL}/admin-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка авторизации');
  }

  return data; // например, { success: true } или { token: '...' }
}

// Получить все слоты (включая забронированные и свободные)
export async function getAllSlots() {
  const response = await fetch(`${API_BASE_URL}/all-slots`);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении слотов');
  }

  return data;
}

// Получить всех пользователей
export async function getAllUsers() {
  console.log('getAllUsers')
  const response = await fetch(`${API_BASE_URL}/users`);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении пользователей');
  }
  console.log('getAllUsers res', data)
  return data;
}

export async function createSlots(untilDate) {
  const response = await fetch(`${API_BASE_URL}/create-slots`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ untilDate }), // передаем дату строкой
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при создании слотов');
  }

  return data; // например, { success: true, createdCount: 10 }
}


export async function getAllTracks() {
  const response = await fetch(`${API_BASE_URL}/media-list`);
  const data = await response.json();
  console.log('getAllTracks', data)
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении списка треков');
  }

  return data;
}

/** Настройки (Zoom и др.) */
export async function getSettings() {
  const response = await fetch(`${API_BASE_URL}/admin/settings`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при получении настроек');
  }
  return data;
}

export async function saveSettings({ zoomLink, zoomMeetingId, zoomPasscode }) {
  const response = await fetch(`${API_BASE_URL}/admin/settings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ zoomLink, zoomMeetingId, zoomPasscode }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при сохранении настроек');
  }
  return data;
}

/** Заменить аудиофайл на бэке (сохраняется то же имя). FormData: category, filename, file. */
export async function uploadMediaReplace(category, filename, file) {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('filename', filename);
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}/admin/media-replace`, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка при замене файла');
  }
  return data;
}
